"use strict";

// References
var alt = require("../alt");
var ItemHistoryActions = require("../actions/ItemHistoryActions");
var _ = require("underscore");


var ItemHistoryStore = alt.createStore(class ItemHistoryStore {
    // Data
    constructor() {
        this.bindActions(ItemHistoryActions);
        this.selectedChangs = {}
        this.allChanges = [
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04bd4f",
                "changes": [
                    {
                            "from": "",
                            "to": "",
                            "property": "new"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-08-07T08:46:00.579Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04c43c",
                "changes": [
                    {
                            "from": "230.000",
                            "to": "300.000",
                            "property": "price"
                    },
                    {
                            "from": "iMac 21\"",
                            "to": "Tölvan hans Nóra",
                            "property": "identifier.name"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-08-10T08:46:00.579Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04c43c",
                "changes": [
                    {
                            "from": "230.000",
                            "to": "300.000",
                            "property": "price"
                    },
                    {
                            "from": "iMac 21\"",
                            "to": "Tölvan hans Nóra",
                            "property": "identifier.name"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-08-10T08:46:00.579Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04c43c",
                "changes": [
                    {
                            "from": "230.000",
                            "to": "300.000",
                            "property": "price"
                    },
                    {
                            "from": "iMac 21\"",
                            "to": "Tölvan hans Nóra",
                            "property": "identifier.name"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-08-10T08:46:00.579Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04c43c",
                "changes": [
                    {
                            "from": "230.000",
                            "to": "300.000",
                            "property": "price"
                    },
                    {
                            "from": "iMac 21\"",
                            "to": "Tölvan hans Nóra",
                            "property": "identifier.name"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-08-10T08:46:00.579Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04c43c",
                "changes": [
                    {
                            "from": "230.000",
                            "to": "300.000",
                            "property": "price"
                    },
                    {
                            "from": "iMac 21\"",
                            "to": "Tölvan hans Nóra",
                            "property": "identifier.name"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-08-10T08:46:00.579Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04c43c",
                "changes": [
                    {
                            "from": "230.000",
                            "to": "300.000",
                            "property": "price"
                    },
                    {
                            "from": "iMac 21\"",
                            "to": "Tölvan hans Nóra",
                            "property": "identifier.name"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-08-10T08:46:00.579Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04c43c",
                "changes": [
                    {
                            "from": "230.000",
                            "to": "300.000",
                            "property": "price"
                    },
                    {
                            "from": "iMac 21\"",
                            "to": "Tölvan hans Nóra",
                            "property": "identifier.name"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-08-10T08:46:00.579Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04cca4",
                "changes": [
                    {
                            "from": "Asus Laptop",
                            "to": "Tölvan hans Óla",
                            "property": "identifier.name"
                    }
                ],
                "type": "itemlog",
                "modifier": "Elvar Örn Þormar",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-06-12T13:26:00.868Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04cca4",
                "changes": [
                    {
                            "from": "",
                            "to": "",
                            "property": "new"
                    }
                ],
                "type": "itemlog",
                "modifier": "Elvar Örn Þormar",
                "uuid": "5e742c7337f2b3b818a1d2686b212e75",
                "version": "1.0",
                "date": "2015-06-12T13:25:48.455Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04cdb7",
                "changes": [
                    {
                            "from": "",
                            "to": "",
                            "property": "new"
                    }
                ],
                "type": "itemlog",
                "modifier": "Elvar Örn Þormar",
                "uuid": "0c33e072398172ace5361d03046934e3",
                "version": "1.0",
                "date": "2015-07-31T21:00:07.716Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04d829",
                "changes": [
                    {
                            "from": "",
                            "to": "",
                            "property": "new"
                    }
                ],
                "type": "itemlog",
                "modifier": "Ólafur Arason",
                "uuid": "4d6af6814a6ff5c61ec6030d35abf4e1",
                "version": "1.0",
                "date": "2015-06-12T13:25:48.455Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04deab",
                "changes": [
                    {
                            "from": "",
                            "to": "",
                            "property": "new"
                    }
                ],
                "type": "itemlog",
                "modifier": "Ólafur Arason",
                "uuid": "51d43c5377a5cc7be2bfddcaf8ffb243",
                "version": "1.0",
                "date": "2015-06-15T12:58:19.089Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04e763",
                "changes": [
                    {
                            "from": "",
                            "to": "",
                            "property": "new"
                    }
                ],
                "type": "itemlog",
                "modifier": "Elvar Örn Þormar",
                "uuid": "fccc88077a2d58e5346122b55b179fc5",
                "version": "1.0",
                "date": "2015-05-20T12:47:50.616Z"
            },
            {
                "_id": "f35382ffd7c0029f098b9e1a6d04edc4",
                "changes": [
                    {
                            "from": "",
                            "to": "",
                            "property": "new"
                    }
                ],
                "type": "itemlog",
                "modifier": "Arnór Geir Halldórsson",
                "uuid": "fccc88077a2d58e5346122b55b17a96b",
                "version": "1.0",
                "date": "2015-05-20T12:47:50.619Z"
            }
        ];
    }

    // Functions
    onGetAllChanges() {
        // Add functionality
    }

    onFilterChanges(_id) {
        // Not used at the moment.
        // Currently we fetch all changes and filter in the component.
        this.selectedChangs = _.filter(this.allChanges, {"_id": _id});
    }

});


module.exports = ItemHistoryStore;



// WEBPACK FOOTER //
// ./app/scripts/stores/ItemHistoryStore.js